import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useNavigate } from '@reach/router';
import { NewSubscriptionParser, NewSubscriptionStep } from './models';
import { ChoosePackageForm } from 'components/choosePackageForm/ChoosePackageForm';
import FormHeader from 'components/formHeader/FormHeader';
import Page from 'components/shared/Page';
import PaymentDetailsForm from 'components/paymentDetailsForm/PaymentDetailsForm';
import { PaymentTypeForm } from 'components/paymentTypeForm/PaymentTypeForm';
import { useDispatch } from 'react-redux';
import {
  clearPackageForm,
  clearPoNumber,
  setValidPromoCode,
  setSchoolAccountContext,
  setQuotePromoCodeSlots,
} from 'reducers/misc';
import ConfirmationBox from 'components/confirmationBox/ConfirmationBox';
import { AppPath, PUBLIC_SITE_URL } from 'appConstants';

const INVOICE_SUCCESS_MESSAGE = {
  title: 'Congratulations!',
  message: 'You have instant access to the platform.',
  buttonText: 'Dashboard',
};

export const NewSubscription: React.FC<RouteComponentProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeStep, setActiveSet] = useState<NewSubscriptionStep>(
    NewSubscriptionStep.CHOOSE_PACKAGE
  );

  useEffect(() => {
    return () => {
      dispatch(clearPackageForm());
      dispatch(clearPoNumber());
      dispatch(setValidPromoCode([]));
      // Keyed by subject, so a code left behind is priced by the next visit without being checked.
      dispatch(setQuotePromoCodeSlots({}));
      dispatch(setSchoolAccountContext(null));
    };
  }, []);

  return (
    <Page>
      <div className="PageContent WidthContent HeightContent SubscribePage">
        <div className="SubscriptionPageHead">
          <FormHeader
            activeStep={activeStep < 3 ? activeStep + 1 : 3}
            numOfSteps={3}
            title={NewSubscriptionParser.getPageHeaderInfo(activeStep).title}
            nextStep={
              NewSubscriptionParser.getPageHeaderInfo(activeStep).nextStep
            }
          />
        </div>
        {activeStep === NewSubscriptionStep.CHOOSE_PACKAGE && (
          <ChoosePackageForm onSubmit={() => setActiveSet(NewSubscriptionStep.PAYMENT_TYPE)} />
        )}

        {activeStep === NewSubscriptionStep.PAYMENT_TYPE && (
          <PaymentTypeForm
            onSubmit={(typeOfPayment: 'card' | 'invoice') =>
              typeOfPayment === 'invoice'
                ? setActiveSet(NewSubscriptionStep.CONFIRMATION)
                : setActiveSet(NewSubscriptionStep.PAYMENT_DETAILS)
            }
          />
        )}

        {activeStep === NewSubscriptionStep.PAYMENT_DETAILS && (
          <PaymentDetailsForm onSubmit={() => setActiveSet(NewSubscriptionStep.CONFIRMATION)} />
        )}
        {activeStep === NewSubscriptionStep.CONFIRMATION && (
          <div className="Success">
            <div className="ConfirmationBoxContainer">
              <ConfirmationBox
                {...INVOICE_SUCCESS_MESSAGE}
                buttonOnClick={() => navigate(AppPath.DASHBOARD)}
              />
            </div>
          </div>
        )}
      </div>
    </Page>
  );
};
